'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { memo } from 'react';
const INLINE_SOURCE_BADGE_BASE = 'inline-flex size-3.5 shrink-0 items-center justify-center rounded-full transition-colors';
// TODO(#web-design-system): Replace these raw premium badge colors with named design tokens.
/** Gold premium badge: dalmasca circle + crown (matches citation bubble accent). */
const PREMIUM_SOURCE_BADGE_ICON_CLASS = [
    INLINE_SOURCE_BADGE_BASE,
    'bg-[oklch(var(--dalmasca-300)/0.36)] text-[oklch(var(--dalmasca-400))]',
].join(' ');
const PREMIUM_SOURCE_BADGE_CLASS = [
    PREMIUM_SOURCE_BADGE_ICON_CLASS,
    // 1px baseline nudge so the inline badge aligns with adjacent text (previously a wrapper span at call sites).
    'relative top-px',
    'transition-[filter,background-color] duration-quick',
    '[@media(hover:hover)]:hover:bg-[oklch(var(--dalmasca-300)/0.52)]',
].join(' ');
const EXPANDED_SOURCE_BADGE_PILL_CLASS = [
    'inline-flex h-5 shrink-0 select-none cursor-default items-center gap-1 rounded-full border border-soft bg-transparent pl-0.5 pr-1 py-0.5',
    'transition-[border-color,background-color,color] duration-quick',
    '[@media(hover:hover)]:hover:border-base',
].join(' ');
// TODO(#web-icon-system): Move this filled crown glyph into the icon sprite system.
export const FilledCrownIcon = memo(function FilledCrownIcon() {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", "aria-hidden": true, className: "size-2.5", children: _jsx("path", { fill: "currentColor", d: "M19 19h-14c-.5 0 -.9 -.3 -1 -.8l-2 -10c0 -.4 .1 -.8 .5 -1.1c.4 -.2 .8 -.2 1.1 0l4.1 3.3l3.4 -5.1c.4 -.6 1.3 -.6 1.7 0l3.4 5.1l4.1 -3.3c.3 -.3 .8 -.3 1.1 0c.4 .2 .5 .6 .5 1.1l-2 10c0 .5 -.5 .8 -1 .8z" }) }));
});
export const InlinePremiumSourceBadge = memo(function InlinePremiumSourceBadge({ ariaLabel }) {
    return (_jsx("span", { role: "img", "aria-label": ariaLabel, className: PREMIUM_SOURCE_BADGE_CLASS, children: _jsx(FilledCrownIcon, {}) }));
});
export const ExpandedPremiumSourceBadge = memo(function ExpandedPremiumSourceBadge({ ariaLabel, label }) {
    return (_jsxs("span", { role: "img", "aria-label": ariaLabel, className: EXPANDED_SOURCE_BADGE_PILL_CLASS, children: [_jsx("span", { className: PREMIUM_SOURCE_BADGE_ICON_CLASS, "aria-hidden": true, children: _jsx(FilledCrownIcon, {}) }), _jsx(TextPrimitive, { variant: "micro", color: "light", className: "leading-none", children: label })] }));
});
//# sourceMappingURL=PremiumSourceBadge.js.map